import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function ValidationField(values) {
  let errors = {};

  errors.customerName = ValidateField(
    values.customerName,
    ValidateName?.CUSTOMER_NAME,
    ValidateName?.CUSTOMER_NAME,
    [ValidateName?.REQUIRED, ValidateName?.NOT_VALID, ValidateName?.MIN_LENGTH],
  );

  errors.address = ValidateField(
    values.address,
    ValidateName?.CUSTOMER_ADDRESS,
    ValidateName?.CUSTOMER_ADDRESS,
    [ValidateName?.REQUIRED],
  );

  errors.phone = ValidateField(
    values.phone,
    ValidateName?.PHONE_NUMBER,
    ValidateName?.PHONE_NUMBER,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_PHONE],
  );
  if (values.website !== "") {
    errors.website = ValidateField(
      values.website,
      ValidateName?.WEBSITE,
      ValidateName?.WEBSITE,
      [ValidateName?.ISVALID_URL],
    );
  }

  errors.email = ValidateField(
    values.email,
    ValidateName?.EMAIL,
    ValidateName?.EMAIL,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_EMAIL],
  );

  errors.countryId = ValidateField(
    values?.countryId,
    ValidateName?.CUSTOMER_COUNTRY,
    ValidateName?.CUSTOMER_COUNTRY,
    [ValidateName?.REQUIRED],
  );

  errors.type = ValidateField(
    values.type,
    ValidateName?.CUSTOMER_TYPE,
    ValidateName?.CUSTOMER_TYPE,
    [ValidateName?.REQUIRED],
  );

  errors.distributorId = ValidateField(
    values.distributorId,
    ValidateName?.DISTRIBUTOR,
    ValidateName?.DISTRIBUTOR,
    [ValidateName?.REQUIRED],
  );

  errors.assignedEngineerId = ValidateField(
    values.assignedEngineerId,
    ValidateName?.ASSIGNED_ENGINEER,
    ValidateName?.ASSIGNED_ENGINEER,
    [ValidateName?.REQUIRED],
  );
  return errors;
}

